/**
 * Shared scroll-lock helpers.
 *
 * Pauses Lenis's smooth scroll and applies `.is-scroll-locked` on <html>
 * so CSS can also block native scrolling (touch, keyboard, wheel).
 * Reference-counted so multiple concurrent lockers don't fight.
 */

let scrollLockCount = 0;

export function lockScroll() {
  scrollLockCount += 1;
  if (scrollLockCount === 1) {
    document.documentElement.classList.add('is-scroll-locked');
    window.lenis?.stop?.();
  }
}

export function unlockScroll() {
  scrollLockCount = Math.max(0, scrollLockCount - 1);
  if (scrollLockCount === 0) {
    document.documentElement.classList.remove('is-scroll-locked');
    window.lenis?.start?.();
  }
}

export function isScrollLocked() {
  return scrollLockCount > 0;
}
